export function getJQuery() {
	const jQuery = (window as any).jQuery;
	if (!jQuery) {
		throw new Error("No jQuery");
	}

	return jQuery;
}
